import { KnownConfigTokens } from "../../knownConfigTokens";

export enum KnownFormToken {
  InterviewAppointmentConfirmationForm = "InterviewAppointmentConfirmationForm",
  InterviewAppointmentProposalForm = "InterviewAppointmentProposalForm",
  InterviewAppointmentScheduleForm = "InterviewAppointmentScheduleForm",
  InterviewAppointmentScheduleSingleDateForm = "InterviewAppointmentScheduleSingleDateForm",
  InterviewFeedbackForm = "InterviewFeedbackForm",
  MatchingAgreementForm = "MatchingAgreementForm",
  MatchingAgreementFormV2 = "MatchingAgreementFormV2",
  ShippingInformationForm = "ShippingInformationForm",
  SubmissionDate = "SubmissionDate",
  CandidateAllowence = "CandidateAllowence", // Warning: Renaming requires a major database migration
  RecruitingConcept = "RecruitingConcept",
  TravelBookingForm = "TravelBookingForm",
  QualificationEvaluationConfiguration = "QualificationEvaluationConfiguration",
  QualificationEvaluationRequest = "QualificationEvaluationRequest",
  QualificationEvaluationReceived = "QualificationEvaluationReceived",
}

export function getDisallowedFormTokens(
  configToken: string | undefined,
  hasGueteSiegel: boolean
): KnownFormToken[] {
  const disallowed: KnownFormToken[] = [];
  if (!hasGueteSiegel) {
    disallowed.push(KnownFormToken.RecruitingConcept);
  }
  if (configToken !== KnownConfigTokens.VIDACTA && configToken !== KnownConfigTokens.CARITAS) {
    disallowed.push(
      KnownFormToken.QualificationEvaluationConfiguration,
      KnownFormToken.QualificationEvaluationRequest,
      KnownFormToken.QualificationEvaluationReceived
    );
  }
  return disallowed;
}
